// extracted by mini-css-extract-plugin
module.exports = {"suspended-container":"styles__suspended-container___3TNUn","suspended":"styles__suspended___2QToc","header":"styles__header___2-ivs","footer":"styles__footer___Qfmwo"};